<template>
  <div class="incenters">
    <div>
      <!--  v-if="qx.add"-->
      <Commonbtn backgroundColor="#FFF"  title="新增" fontSize="14px" :src="require('@/assets/icon/icon-add.png')" @btnclick="adduser">
      </Commonbtn>
      <!-- v-if="qx.update" -->
      <Commonbtn backgroundColor="#FFF" title="修改" fontSize="14px" :src="require('@/assets/icon/icon-update.png')" @btnclick="update">
      </Commonbtn>
      <!-- v-if="qx.del" -->
      <Commonbtn   backgroundColor="#FFF" title="删除" fontSize="14px" :src="require('@/assets/icon/icon-del.png')" @btnclick="del">
      </Commonbtn>
      <!-- v-if="qx.enabled"  -->
      <Commonbtn backgroundColor="#FFF" :title="enabledText" fontSize="14px" :src="enabledImg" @btnclick="deactivate">
      </Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick" colnum=34 :tableData="tableData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="680px" title="新增用户" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from">
        <template v-for="(item , index) of fromdataadd">
          <Commondropdownlist :key="index" ref="add" :checkboxdata="item.checkboxdata" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" @cascaderchange="cascaderchange"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <DialogFrom width="680px" title="修改用户" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="from">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist :key="index" ref="update" :checkboxdata="item.checkboxdata" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" @cascaderchange="cascaderchange"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该菜单吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate" @dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停启用该菜单吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import Commontable from '../../../components/common-table.vue'
import Commonbtn from '../../../components/common-btn.vue'
import Pagination from '../../../components/pagination.vue'
import DialogFrom from '../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import Dialog from '../../../components/dialog.vue'
import {
  MenuListadd,
  MenuListdetails,
  MenuListEdit,
  MenuListdel,
  MenuListSetEnable,
  SearchList
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog
  },
  props: {
    tableData: {
      type: Array,
      default: []
    },
    total: {
      type: Number,
      default: 1
    }
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibledeactivate: false,
      rightboo: false,
      dwonleft: false,
      username: '',
      name: '',
      ptype: '',
      rowboo: false,
      p_MenuID: null,
      menuIDts: null,
      MenuID: '',
      fromdataadd: [],
      fromdataedit: [],
      resdetailsList: {},
      enabledText: "停用",
      enabledImg: require('@/assets/icon/icon-stop.png'),
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false
      },
      qus: [],
      tableData1: [{
        id: '1',
        zuz: '445',
        zuzname: '北京中兴昊然医疗技术有限公司',
      },
      {
        id: '1',
        zuz: 'ZX558888',
        zuzname: '北京中兴昊然医疗技术有限公司',
      },
      {
        id: '1',
        zuz: 'ZX558888',
        zuzname: '北京中兴昊然医疗技术有限公司',
      },
      ],
    }
  },
  watch: {

  },
  created() {

  },
  async mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.searchList()
    // this.QX()
    //console.log("qux", this.qus)
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      let NodeID = this.$route.query.NodeID
      data.Menus.map((item, index) => {
        if (item.NodeID == 1) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 5) {
              this.qus = items.Nodes
            }
          })
        }
      })
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          }
        })
      }
    },
    async searchList() {
      let {
        code,
        data
      } = await SearchList({

      })
      if (code == 0) {
        this.fromdataadd[0].options = data
        fromdata[0].options = this.fromdataadd[0].options
        this.fromdataedit[0].options = data
        fromdataedit[0].options = this.fromdataedit[0].options
      }
    },
    // 停用
    async menuListSetEnable(InActive) {
      let menusetenable = await MenuListSetEnable({
        MenuID: this.MenuID,
        Enabled: this.enabledText == "启用" ? 1 : 0
      })
      if (menusetenable.code == 0) {
        this.$message({
          type: 'success',
          message: menusetenable.message
        });
        this.$parent.menuList();
        this.rowboo = false
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: menusetenable.message
        });
      } else {
        this.$message({
          type: 'error',
          message: menusetenable.message
        });
      }
    },
    // 删除
    async menuListdel() {
      let menudel = await MenuListdel({
        MenuID: this.MenuID
      })
      if (menudel.code == 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.rowboo = false
        this.$parent.menuList();
      } else {
        this.$message({
          type: 'info',
          message: menudel.message
        });
      }
    },
    // 修改
    async menuListEdit(datalist) {
      let menulistedit = await MenuListEdit({
        MenuID: this.MenuID,
        p_MenuID: datalist[0].modelvalue,
        sortID: Number(datalist[4].modelvalue),
        menuCode: datalist[1].modelvalue,
        MenuName: datalist[2].modelvalue,
        formName: datalist[3].modelvalue,
        IsShow: datalist[5].modelvalue,
        IsCusWeb: datalist[6].modelvalue
      })
      if (menulistedit.code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.$parent.menuList();
        this.rowboo = false
      } else {
        this.$message({
          type: 'info',
          message: menulistedit.message
        });
      }
      //console.log(menulistedit, "menulistedit")
    },
    // 详情
    async menuListdetails() {
      let resdetails = await MenuListdetails({
        menuID: this.MenuID,
      })
      //console.log("详情", resdetails)
      if (resdetails.code == 0) {
        if (resdetails.data) {
          // //console.log(typeof(resdetails.data.P_MenuID.toString()));
          // this.p_MenuID = resdetails.data.P_MenuID
          fromdataedit[0].inputdata = resdetails.data.P_MenuID.toString()
          fromdataedit[1].inputdata = resdetails.data.MenuCode
          fromdataedit[2].inputdata = resdetails.data.MenuName
          fromdataedit[3].inputdata = resdetails.data.FormName
          fromdataedit[4].inputdata = resdetails.data.SortID
          fromdataedit[5].inputdata = String(resdetails.data.IsShow)
          fromdataedit[6].inputdata = String(resdetails.data.IsCusWeb)
          this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))

        }
      }

    },
    // 新增
    async menuListInfo(datalist) {
      let resmenuInfo = await MenuListadd({
        menuName: datalist[2].modelvalue,
        p_MenuID: datalist[0].modelvalue,
        sortID: Number(datalist[4].modelvalue),
        menuCode: datalist[1].modelvalue,
        formName: datalist[3].modelvalue,
        IsShow: datalist[5].modelvalue,
        IsCusWeb: datalist[6].modelvalue
      })
      if (resmenuInfo.code == 0) {
        this.$message({
          type: 'success',
          message: '添加成功！'
        });
        this.$parent.menuList();
      } else {
        this.$message({
          type: 'error',
          message: resmenuInfo.message
        });
      }
      this.$refs.add.map((item, index) => {
        //console.log(item, "item")
        item.modelvalue = ''
      })
    },

    commclick(type) {
      this[type] = true
    },

    onRowClick(val) {
      // //console.log("行", val.Enabled)
      this.MenuID = val.MenuID
      //console.log(this.$refs.update)
      if (val.Enabled == 1) {
        this.enabledText = "停用"
        this.enabledImg = require('@/assets/icon/qy.png')
      } else {
        this.enabledText = "启用"
        this.enabledImg = require('@/assets/icon/icon-stop.png')
      }
      this.rowboo = true
    },

    cascaderchange(e) {
      //console.log('NODE', e)
      this.p_MenuID = e
    },
    adduser() {
      this.p_MenuID = ''
      this.dialogVisibles = true
      //console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
    },
    cancel() {
      this.$refs.add.map((item, index) => {
        //console.log(item, "item")
        item.modelvalue = ''
      })
      this.dialogVisibles = false
    },
    dialogOK() {
      //console.log('add', this.$refs.add)
      // this.$refs.add.map((item , index) => {
      //   //console.log(item.inputdata,"daadd")
      // }

      this.menuListInfo(this.$refs.add)
      this.dialogVisibles = false

    },
    update() {
      if (this.rowboo == true) {
        this.dialogVisiblesedit = true
        this.menuListdetails()
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });
    },
    canceledit() {
      //console.log("canceledit", this.rowboo)
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.rowboo = false
      //console.log("canceledit", this.rowboo)
      this.dialogVisiblesedit = false
      this.menuListEdit(this.$refs.update)
    },
    del() {
      if (this.rowboo == true) {
        this.dialogVisibledel = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要删除的数据！'
      });
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {

      this.dialogVisibledel = false
      this.menuListdel()

    },
    deactivate() {
      if (this.rowboo == true) {
        this.dialogVisibledeactivate = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要停启用的数据！'
      });
    },
    canceldeactivate() {
      this.dialogVisibledeactivate = false
    },
    dialogOKdeactivate() {
      this.menuListSetEnable()
      this.dialogVisibledeactivate = false
    },
    handleCurrentChange(pageindex) {
      this.$emit('handleCurrentChange', pageindex)
    },
    handleSizeChange(paegSzie) {
      this.$emit('handleSizeChange', paegSzie)
    },
  },

}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}
.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}
.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}
.dwonleft:hover {
  background-color: #f0f0f0;
}
</style>
